/**
 * ROIComparisonText Component
 *
 * One plain, factual sentence comparing Race Day and Late Mail returns at a track.
 * Compliance (owner, 2 Nov 2026): no claims of value, advantage or success, no advice to bet.
 */

const formatReturn = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return "n/a";
  const sign = n > 0 ? "+" : n < 0 ? "\u2212" : "";
  return `${sign}${Math.abs(n).toFixed(1)}%`;
};

export default function ROIComparisonText({ earlyROI, raceTimeROI }) {
  const description = `At this track, $1 on every Race Day tip has returned ${formatReturn(earlyROI)} and $1 on every Late Mail tip ${formatReturn(raceTimeROI)}, at Betfair starting price before commission. Past results don't predict future ones.`;

  return <p className="text-gray-700 leading-relaxed">{description}</p>;
}
